<template>
  <Fieldset legend="Spreadsheet Info" pt:content:class="py-0!">
    <div class="flex flex-row justify-evenly items-center">
      <div class="flex flex-row">
        <p class="font-bold my-auto">Tab #</p>
        <InputNumber
          v-model="importData.tab"
          showButtons
          increment-button-class="py-0! w-full"
          decrement-button-class="py-0! w-full"
          :min="1"
          class="h-10 ml-3"
          inputClass="w-16 pe-0"
          :allowEmpty="false"
          :disabled="file == null ? false : file.name.endsWith('.csv')"
          pt:buttonGroup:class="w-6!"
        ></InputNumber>
      </div>
      <div class="flex flex-row">
        <p class="font-bold my-auto">Budget Start Row</p>
        <InputNumber
          v-model="importData.startRow"
          showButtons
          :min="1"
          increment-button-class="py-0! w-full"
          decrement-button-class="py-0! w-full"
          class="h-10 ml-3"
          inputClass="w-16 pe-0"
          :allowEmpty="false"
          pt:buttonGroup:class="w-6!"
        ></InputNumber>
      </div>
      <div class="flex flex-row">
        <p class="font-bold my-auto">Budget End Row</p>
        <InputNumber
          v-model="importData.endRow"
          showButtons
          :min="1"
          increment-button-class="py-0! w-full"
          decrement-button-class="py-0! w-full"
          class="h-10 ml-3"
          inputClass="w-16 pe-0"
          :allowEmpty="false"
          pt:buttonGroup:class="w-6!"
        ></InputNumber>
      </div>
    </div>
  </Fieldset>

  <Fieldset legend="Column Info" pt:content:class="py-0!">
    <div class="flex flex-row justify-evenly">
      <div class="flex flex-col text-end text-sm">
        <ImportColumnPicker v-model:column="fieldData.lineRefCol" :columns label="Line Ref # Column"></ImportColumnPicker>
        <ImportColumnPicker v-model:column="fieldData.descriptionCol" :columns label="Description Column"></ImportColumnPicker>
        <ImportColumnPicker v-model:column="fieldData.budgetAmtCol" :columns label="Budget Amount Column"></ImportColumnPicker>
        <ImportColumnPicker
          v-if="initialBudget"
          v-model:column="fieldData.initBudgetAmtCol"
          :columns
          label="Initial Budget Amount Column"
        ></ImportColumnPicker>
        <ImportColumnPicker v-model:column="fieldData.priorDrawnToDateCol" :columns label="Prior Drawn to Date Column"></ImportColumnPicker>
        <ImportColumnPicker v-model:column="fieldData.thisDrawAmtCol" :columns label="This Draw Amount Column"></ImportColumnPicker>
      </div>
      <div class="flex flex-col text-end text-sm">
        <ImportColumnPicker
          v-model:column="fieldData.priorEquityDrawnToDateCol"
          :columns
          label="Prior Equity Draw Amount Column"
        ></ImportColumnPicker>
        <ImportColumnPicker v-model:column="fieldData.thisEquityDrawAmtCol" :columns label="This Equity Draw Amount Column"></ImportColumnPicker>
        <ImportColumnPicker
          v-if="!hideInspection"
          v-model:column="fieldData.inspPriorDrawCol"
          :columns
          label="Inspection Prior Draw Column"
        ></ImportColumnPicker>
        <ImportColumnPicker
          v-if="!hideInspection"
          v-model:column="fieldData.inspThisDrawCol"
          :columns
          label="Inspection This Draw Column"
        ></ImportColumnPicker>
        <ImportColumnPicker
          v-model:column="importData.defaultCostType"
          :columns="costTypes"
          label="Default Cost Type"
          size="w-32"
        ></ImportColumnPicker>
      </div>
    </div>
  </Fieldset>
</template>

<script setup lang="ts">
import type { ImportBudget } from "@/types/Import";

const importData = defineModel<ImportBudget>("importData", { required: true });
const fieldData = defineModel<any>("fieldData", { required: true });

interface Props {
  file: File | null;
  initialBudget?: boolean;
  hideInspection?: boolean;
}

const props = withDefaults(defineProps<Props>(), {
  initialBudget: false,
  hideInspection: false,
});

const columns = " ABCDEFGHIJKLMNOPQRSTUVWXYZ".split("");
const costTypes = ["INSP", "NONINSP"];
</script>
